import { Link } from "react-router-dom";

/**
 * ETA row for shipment board card footers; label includes the secondary identifier when set.
 * @param {Object} props
 * @param {number|string} props.orderId Consignment id for the detail route.
 * @param {string} [props.reference] Secondary identifier (shipment name or number, depending on card title).
 * @param {boolean} [props.showReferenceLabel=true] When false, omit the reference from the ETA label.
 * @param {string} props.etaDisplay Formatted ETA or fallback label.
 * @param {string} [props.linkTo] Detail route for the secondary identifier link.
 * @return {React.ReactElement}
 */
export function ShipmentBoardFooterMeta({
  orderId,
  reference,
  showReferenceLabel = true,
  etaDisplay,
  linkTo,
}) {
  const trimmedReference = reference?.trim();
  const detailLink = linkTo ?? `${orderId}`;

  return (
    <div className="etaDetails">
      {showReferenceLabel && trimmedReference ? (
        <span className="etaDetailsLabel">
          <span className="etaDetailsLabelPrefix">ETA for</span>
          <Link className="shipmentBoardNameLink" to={detailLink} title={trimmedReference}>
            {trimmedReference}
          </Link>
        </span>
      ) : (
        <span>ETA</span>
      )}
      <strong>{etaDisplay}</strong>
    </div>
  );
}
